import styled from 'styled-components';

import ImageWithSkeleton from '~atoms/ImageWithSkeleton';

export const PreviewContainer = styled.div({
  position: 'relative',
});

export const TrendBadge = styled.div(({ theme }) => ({
  background: theme.defaultTheme.trendColor,
  color: theme.palette.white,
  fontSize: '12rem',
  padding: '0 10rem',
  position: 'absolute',
  top: '5rem',
}));

export const PreviewImage = styled(ImageWithSkeleton)({
  width: '100%',
  maxWidth: '958rem',
  height: '450rem',
  '& img': {
    objectFit: 'cover',
  },
});
